import * as React from "react";

const SpeakerMenuIcon = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 2.707C9 1.816 7.923 1.37 7.293 2l-3 3H3.005c-.76 0-1.545.443-1.773 1.27A6.507 6.507 0 0 0 1 8c0 .599.08 1.179.233 1.73.228.827 1.012 1.27 1.773 1.27h1.287l3 3c.63.63 1.707.184 1.707-.707V2.707Zm3.39.697a.5.5 0 0 1 .706 0 6.499 6.499 0 0 1 0 9.192.502.502 0 0 1-.72.013.5.5 0 0 1 .013-.72 5.5 5.5 0 0 0 0-7.778.5.5 0 0 1 0-.707Z"
      fill="#95959E"
    />
    <path
      d="M10.621 5.171a.5.5 0 0 1 .708 0 4 4 0 0 1 0 5.658.5.5 0 0 1-.707-.708 3.001 3.001 0 0 0 0-4.242.5.5 0 0 1 0-.707Z"
      fill="#95959E"
    />
  </svg>
);

export default SpeakerMenuIcon;
